<template>
  <div class="lot-item" :title="lot.lotName">
    <span class="name">{{ lot.lotName }}</span>
  </div>
</template>

<script>
export default {
  name: "BitrixExportLotItem",
  props: {
    lot: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="less" scoped>
.lot-item {
  height: 46px;
  border-bottom: 2px solid #edeff1;
  display: flex;
  align-items: center;
  position: relative;
  .name {
    font-family: Roboto;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &:last-child {
    border: none;
  }
  &::before {
    content: "";
    position: absolute;
    top: -33px;
    left: -26px;
    width: 12px;
    height: calc(100% + 10px);
    border-left: 1px solid #cfd8dd;
    border-bottom: 1px solid #cfd8dd;
    border-bottom-left-radius: 6px;
  }
  &:first-child::before {
    height: 50%;
    top: 0;
  }
}
</style>
